import React, {Component} from 'react';
import LocalizedStrings from '../../localization/strings';

import Select from '../form/select';
export default class DistanceSelection extends Component {
    render() {
        if (!this.props.distances) {
            return null;
        }
        return (<Select clearable={true} options={this.props.distances} noResultsText={LocalizedStrings.noDistances} placeholder={LocalizedStrings.distance} onChange={this.props.onChange} value={this.props.value} searchable={false} resetValue={null}/>)
    }
}



// WEBPACK FOOTER //
// ./src/js/components/filters/distance-filter.js